const pendingPageviews = []

let lastCountedPath = null
let retryTimer = null

const flushPageviews = () => {
  if (
    typeof window === "undefined" ||
    !window.goatcounter ||
    typeof window.goatcounter.count !== "function"
  ) {
    return false
  }

  while (pendingPageviews.length > 0) {
    const pageview = pendingPageviews.shift()

    if (pageview.path !== lastCountedPath) {
      window.goatcounter.count(pageview)
      lastCountedPath = pageview.path
    }
  }

  return true
}

exports.onRouteUpdate = ({ location }) => {
  const path = `${location.pathname}${location.search}${location.hash}`
  const queuedPath = pendingPageviews[pendingPageviews.length - 1]?.path

  if (path === lastCountedPath || path === queuedPath) {
    return
  }

  pendingPageviews.push({ path, title: document.title })

  if (flushPageviews() || retryTimer) {
    return
  }

  let attempts = 0
  retryTimer = window.setInterval(() => {
    attempts += 1

    if (flushPageviews() || attempts >= 50) {
      window.clearInterval(retryTimer)
      retryTimer = null
    }
  }, 100)
}
